<div class="sidebar d-none d-lg-flex align-content-between flex-wrap" [class.sidebar-open]="isOpen()">
    <div style="width: 100%;">
        <div class="sidebar-header">
            <h5 class="app-name mt-3 mb-1 mb-lg-3 text-center" [class.d-none]="!isOpen()"
                [class.d-lg-block]="!isOpen()">
                ZAPROSILA
            </h5>
        </div>
        <ul class="navbar-nav">
            <li class="nav-item">
                <a class="nav-link d-flex align-items-center py-2" routerLink="/claim-inquiry">
                    <i class="fas fa-envelope me-2"></i>
                    <span [class.d-none]="!isOpen()" [class.d-lg-inline]="!isOpen()" [class.d-inline]="isOpen()"
                        style="font-size: 1rem;">
                        Zaprosila
                    </span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link d-flex align-items-center py-2" routerLink="/settings">
                    <i class="fas fa-cog me-2"></i>
                    <span [class.d-none]="!isOpen()" [class.d-lg-inline]="!isOpen()" [class.d-inline]="isOpen()"
                        style="font-size: 1rem;">
                        Nastavitve
                    </span>
                </a>
            </li>
            @if (isAdmin()) {
                <li class="nav-item">
                    <a class="nav-link d-flex align-items-center py-2" routerLink="/admin">
                        <i class="fas fa-tools me-2"></i>
                        <span [class.d-none]="!isOpen()" [class.d-lg-inline]="!isOpen()" [class.d-inline]="isOpen()"
                            style="font-size: 1rem;">
                            Administracija
                        </span>
                    </a>
                </li>
            }
            @if (userName()) {
                <li class="nav-item d-lg-none">
                    <span class="nav-link d-flex align-items-center py-2 user-name">
                        <i class="fa fa-user fa-fw me-2"></i>
                        {{ userName() }}
                    </span>
                </li>
            }
            <li class="nav-item d-lg-none">
                <a class="nav-link d-flex align-items-center py-2" href="/mojszz">
                    <i class="fas fa-home me-2"></i>
                    Moj SZZ
                </a>
            </li>
            <div class="docs-design">
                <li class="nav-item d-lg-none">
                    <a class="nav-link d-flex align-items-center py-2" role="button" tabindex="0"
                        (click)="onLogout()" (keydown.enter)="$event.preventDefault(); onLogout()" (keydown.space)="$event.preventDefault(); onLogout()">
                        <i class="fas fa-sign-out-alt me-2"></i>
                        Odjava
                    </a>
                </li>
                <a class="nav-link-bottom" download="administracija-uporabnikov-prirocnik.pdf"
                    href="assets/docs/administracija-uporabnikov-prirocnik.pdf">
                    <i class="fas fa-exclamation-circle me-2 text-warning"></i>
                    <span [class.d-none]="!isOpen()" [class.d-lg-inline]="!isOpen()" [class.d-inline]="isOpen()">
                        Uporabniški priročnik
                    </span>
                </a>
            </div>
        </ul>
    </div>
</div>
